<template>
  <input-cleave
    type="text"
    class="input input--border input--radius"
    :id="id"
    :name="name"
    :placeholder="placeholder"
    :disabled="disabled"
    :options="options"
    :format="formatIban"
    :unformat="unformatIban"
    v-bind="$attrs"
    v-model="iban"
    @blur="handleInputBlurred"
  />

  <p
    class="input--errors input--error"
    v-if="v?.$error"
  >
    <template v-if="v.required?.$invalid">
      {{ t('errors.input_text_required') }}
    </template>

    <template v-if="v.iban?.$invalid">
      {{ t('errors.input_text_invalid_iban') }}
    </template>
  </p>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { get as _get, chunk as _chunk } from 'lodash'
import { countrySpecs } from 'ibantools'
import { formatGeneral, unformatGeneral } from 'cleave-zen'

import InputCleave from '&/atoms/InputCleave'

const model = defineModel({ type: String, default: '' })

const { v } = defineProps({
  id: String,
  name: { type: String, default: 'input-iban' },
  placeholder: { type: String, default: '...' },
  disabled: { type: Boolean, default: false },
  v: Object
})

const { t } = useI18n()

const length = computed(() => {
  const { chars = 40 } = _get(countrySpecs, model.value?.slice(0, 2), {})

  return chars
})

const blocks = computed(() => _chunk(Array(length.value), 4).map(array => array.length))

const options = computed(() => ({ blocks: blocks.value, delimiter: ' ', uppercase: true }))

const iban = computed({
  get: () => model.value || '',
  set: value => model.value = value?.slice(0, length.value)
})

const formatIban = value => formatGeneral(value, options.value)
const unformatIban = value => unformatGeneral(value, options.value)

const handleInputBlurred = () => v?.$touch()
</script>
